import React, { Component } from 'react';
import styles from './selectFeaturedCharity.less';
import {
  Row,
  Col,
  Icon,
  Alert,
  Link,
  BodyText,
  HeadingText,
  CaptionText,
  V2WebsiteIcon,
  v2blue600,
  v2white,
  v2neutral300,
  v2blue400,
  v2neutral100,
  V2CloseIcon,
  Badge,
} from '@paypalcorp/pp-react';
import * as analytics from '../../lib/analytics';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import DonateBox from '../../components/donateBox';
import DonationTerms from '../donation-terms';
import { getType } from '../../lib/charity';
import Spinner from '../spinner/Spinner';
import SetPreferredHeart from '../SetPreferredHeart/SetPreferredHeart';
import utils from '../../lib/utils';
import MediaQuery from 'react-responsive';
import glamorous from 'glamorous';
import { getIsLoggedIn } from '../../lib/header';

const SelectedCharityPanel = glamorous.div({
  background: v2white,
  boxSizing: 'border-box',
  '@media(max-width: 500px)': {
    padding: '4px 0px',
    boxSizing: 'border-box',
  },
  '@media(min-width: 500px)': {
    padding: '24px 24px 0px',
    border: `1px solid ${v2neutral300}`,
    borderRadius: '12px',
  },
});

const BackText = {
  cursor: 'pointer',
  fontSize: '18px',
  lineHeight: '24px',
  color: `${v2blue400} !important`,
  marginLeft: '3px',
};

const LinkIcon = {
  display: 'flex',
  justifyContent: 'center',
  padding: '10px 12px',
  borderRadius: '30px',
  backgroundColor: v2neutral100,
  height: '48px',
  width: '48px',
  margin: '0px 16px 0px 0px',
  color: v2blue600,
  textAlign: 'center',
};

const LinkInfo = {
  display: 'flex',
  padding: '24px 0px',
  color: v2blue400,
};

const LinkInfoMobile = {
  display: 'flex',
  padding: '12px 0px',
  color: v2blue400,
};

export default class SelectedFeaturedCharity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showToastPreferredMessage: this.props.showToastPreferredMessage,
    };
  }

  componentDidMount() {
    const { authState } = JSON.parse(
      document.getElementById('data-props').innerHTML
    );

    const { country: contentCountry } = JSON.parse(
      document.getElementById('data-locale').innerHTML
    );

    analytics.instance.recordEvent(analytics.events.DW_GIVING_TILE_SHOWN, {
      e: 'im',
      item_name: 'dw_giving',
      account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
      state: 'populated',
      scope: 'tile',
      module: 'charity',
      tile_id: this.props.charity.nonprofit_id,
      card_type: 'charity',
      tile_id_type: 'crid',
      charityName: this.props.charity.name || '',
      lcid: '-', // TODO Check how to get the lcid
      acct_cntry: contentCountry,
      order: 1,
    });

    analytics.instance.recordEvent(analytics.events.DW_GIVING_TILE_LOADED, {
      e: 'im',
      item_name: 'dw_giving',
      account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
      state: 'populated',
      scope: 'tile',
      module: 'charity',
      tile_id: this.props.charity.nonprofit_id,
      card_type: 'charity',
      tile_id_type: 'crid',
      charityName: this.props.charity.name || '',
      lcid: '-', // TODO Check how to get the lcid
      acct_cntry: contentCountry,
      order: 1,
    });
  }

  handleKeyPressOnNavBack(e) {
    if (e.key === 'Enter') {
      this.props.handleBackNavigation();
    }
  }

  handleKeyPress(e, callback) {
    if (e.key === 'Enter') {
      return callback();
    }
  }

  charityLogo(charity, index) {
    return (
      <div>
        <div
          className={styles.charityImage}
          id={`charity-avatar-${index}`}
          style={{
            background: `url(${charity.logo_url}) no-repeat center, center`,
            backgroundSize: 'contain',
          }}
          data-nemo='npo-avatar'
        />
      </div>
    );
  }

  charityName(charity) {
    let charityName = charity.name || '';
    let charityNameLength = charityName.length;

    // need to trim the name only if there is a need and display issue.
    let charityNameStripped;
    if (charityNameLength > 40) {
      charityNameStripped = charityName.substr(0, 40).concat('...');
    }

    return (
      <div className={'charityName'}>
        <BodyText as='p' size='md' className={'charitytext'} strong>
          {charity.name}
        </BodyText>
      </div>
    );
  }

  charityCategories(charity) {
    let categories = [];
    if (Array.isArray(charity.cause_area)) {
      categories =
        uniq(
          charity.cause_area.map((causeArea) =>
            this.props.i18n(`label.category-${causeArea.id}`)
          )
        ) || [];
    }

    const charityCategories = categories.map((category, categoryIndex) => {
      return (
        <Badge
          className={styles['link-tiles']}
          style={{
            borderRadius: '14px',
          }}
          key={categoryIndex}
          type='feature'
        >
          {category}
        </Badge>
      );
    });
    return <div className={styles.categoryList}>{charityCategories}</div>;
  }

  setPreferredFetch = (charity) => {
    this.setState(
      {
        isLoading: true,
        heartError: false,
      },
      () => {
        fetch('/fundraiser/setPreferredCharity', {
          method: 'POST',
          body: JSON.stringify({
            _csrf: this.props.csrf,
            npid: charity.nonprofit_id,
            setPreferred:
              this.props.preferredCharityNpid !== charity.nonprofit_id,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.status >= 400) {
              this.setState({
                isLoading: false,
                heartError: true,
                showToastPreferredMessage: true,
              });
            } else {
              return response.json();
            }
          })
          .then((data) => {
            const { setPreferredSuccess } = data;
            if (setPreferredSuccess) {
              this.setState({
                isLoading: false,
                showToastPreferredMessage: true,
              });
              this.props.handleSetFavCharityChange();
              analytics.trackLinkWithData(
                'featuredCharityHeartClicked',
                this.props.fptiInfo.pgrp,
                this.props.fptiInfo.page,
                {
                  charityFavorited:
                    this.props.preferredCharityNpid === charity.nonprofit_id,
                  crid: charity.nonprofit_id,
                },
                'link'
              );
            } else {
              this.setState({
                isLoading: false,
                heartError: true,
                showToastPreferredMessage: true,
              });
            }
          });
      }
    );
  };

  renderSetPreferred(charity, isLoggedIn) {
    const charityType = get(charity, 'charity_type', 'PPGF').toUpperCase();
    const isUnEnrolled =
      charityType === 'PPGF_UNENROLLED' ||
      charityType === 'EXTERNAL' ||
      charityType === 'GUIDESTAR';
    const isMerchant = this.props.userType === 'BUSINESS';
    if (
      this.props.isCountrySetPreferredSupported &&
      !isUnEnrolled &&
      !isMerchant
    ) {
      return (
        <div>
          {this.state.isLoading ? (
            <div className={styles.spinner}>
              <Spinner size='sm' />
            </div>
          ) : (
            <Link
              href={
                !isLoggedIn
                  ? utils.getUnifiedLoginURL(this.props.unifiedLoginURL, [
                      {
                        key: 'setPreferredNpid',
                        value: charity.nonprofit_id,
                      },
                    ])
                  : undefined
              }
              data-nemo={!isLoggedIn ? 'npo-heart-link' : undefined}
              onClick={() => {
                if (isLoggedIn) {
                  this.setPreferredFetch(charity);
                }
              }}
              style={LinkIcon}
              tabIndex={0}
            >
              <SetPreferredHeart
                selected={
                  this.props.preferredCharityNpid === charity.nonprofit_id
                }
                i18n={this.props.i18n}
                hubFlow={true}
                charityName={charity.name}
                nonprofitId={charity.nonprofit_id}
                showToastPreferredMessage={this.state.showToastPreferredMessage}
                // This validation is need to handle three different scenarios
                // 1. If the user doesn't have a favorite charity the value of this prop will be null
                // 2. If the user has a favorite charity and this one is the same that the one that is currently checking this prop will be null
                // 3. If the user has a favorite charity but this one is the different from the one that is currently checking this prop will be the id of that charity
                //
                isPreferredCharitySwitch={
                  this.props.preferredCharityNpid !== charity.nonprofit_id &&
                  this.props.preferredCharityNpid !== null
                }
                hasError={this.state.heartError}
                errorMessage={this.props.i18n('label.setPref-errorAlert')}
              />
            </Link>
          )}
        </div>
      );
    }
  }

  renderCharityInfo(charity, selectedIndex) {
    const npoUrl = `${this.props.npoBaseUrl}${charity.nonprofit_id}`;
    const isLoggedIn = getIsLoggedIn(this.props.authState);
    const setPreferred = this.renderSetPreferred(charity, isLoggedIn);
    const charityInfo = (
      <div className={styles.charityInfoDiv}>
        <div className={styles.charityImageContainer}>
          {this.charityLogo(charity, selectedIndex)}
        </div>
        <div style={{ marginTop: '12px', marginBottom: '15px' }}>
          {this.charityName(charity)}
          {this.charityCategories(charity)}
        </div>
        <MediaQuery maxWidth={600}>
          <div className={styles.charityInfoButtons}>
            {setPreferred}
            <div style={{ display: 'flex' }}>
              <Link
                onClick={() => {
                  this.props.handleInfoClick();
                  window.open(npoUrl);
                }}
                style={LinkInfoMobile}
              >
                {this.props.i18n('label.infoIcon')}
              </Link>
            </div>
          </div>
        </MediaQuery>
        <MediaQuery minWidth={601}>
          <div className={styles.charityInfoButtons}>{setPreferred}</div>
          <div style={{ display: 'flex' }}>
            <Link
              onClick={() => {
                this.props.handleInfoClick();
                window.open(npoUrl);
              }}
              style={LinkInfo}
              tabIndex={0}
            >
              {this.props.i18n('label.infoIcon')}
            </Link>
          </div>
        </MediaQuery>
      </div>
    );
    return charityInfo;
  }

  renderBackLink() {
    return (
      <Link
        className={styles.backNav}
        tabIndex='0'
        role='link'
        onKeyDown={this.handleKeyPressOnNavBack.bind(this)}
        onClick={() => this.props.handleBackNavigation()}
        aria-label={this.props.i18n('label.close')}
      >
        <V2CloseIcon className={styles.backIconColor} size='sm' />
      </Link>
    );
  }

  renderDonationBox(charity) {
    let npid = charity.nonprofit_id;
    // TODO This formUrl is very Important piece of code. Need to think how to make it more secure
    const formUrl = this.props.coBrand + 'charity/' + npid + '/xo/create';
    return (
      <DonateBox
        charity={charity}
        id={charity.nonprofit_id}
        amounts={this.props.amounts}
        csrf={this.props.csrf}
        coBrand={this.props.coBrand}
        formUrl={formUrl}
        charityContent={charity.charityContent}
        enable={this.props.enable}
        fptiInfo={this.props.fptiInfo}
        i18n={this.props.i18n}
        cdnHost={this.props.cdnHost}
      />
    );
  }

  renderDonationTerms(charity) {
    const type = getType(charity);
    const charityContent = charity.charityContent;
    return (
      <div className={styles.donationTermsDiv}>
        <DonationTerms
          type={type}
          charity={charity}
          i18n={this.props.i18n}
          donationTerms={charityContent.donationTerms}
        />
      </div>
    );
  }

  render() {
    const charity = this.props.charity;
    const selectedIndex = this.props.selectedIndex;

    return (
      <SelectedCharityPanel>
        <Row>
          <MediaQuery minWidth={500}>{this.renderBackLink()}</MediaQuery>
          <HeadingText as='h3' size='md' className={styles.selectedHeader}>
            {this.props.i18n('label.charity-module-chooseAmount')}
          </HeadingText>
        </Row>
        <Row style={{ padding: '10px' }}>
          <Col lg='3'>{this.renderCharityInfo(charity, selectedIndex)}</Col>
          <Col
            lg='6'
            className={`slideInRight hasError ${styles['donation-form-container']}`}
          >
            {this.renderDonationBox(charity)}
          </Col>
          <Col
            lg='3'
            style={{ paddingRight: '0px' }}
            className={styles['donation-terms-container']}
          >
            {this.renderDonationTerms(charity)}
          </Col>
        </Row>
      </SelectedCharityPanel>
    );
  }
}
